module.exports = __webpack_public_path__ + "static/media/master.bfe23f92.svg";